module.exports = "/assets/novos-3-co2-sensor.jpg";